import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';
import sortSVG from 'features/creativeFunctionality/img/sort.svg';
import TableRow from './CustomPageTableRow/CustomPageTableRow';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';
import { customTableHeaders } from 'features/creativeFunctionality/data';
import Modal from 'components/ModalProvider/Modal/Modal';
import { useSortArray } from 'hooks/useSortArray';
import CustomRequestDetails from '../CustomRequestDetails/CustomRequestDetails';

import './CustomPageTable.scss';

const b = block('custom-page-table');

const CustomPageTable = ({ model }) => {
  const locale = useSelector(state => state.locale.locale);
  const { input, output } = model;
  const items = output?.requests?.items ?? [];

  const { sortedItems, sortBy, handleSetSortBy } = useSortArray({
    items,
    defaultField: 'netwin',
  });

  const rows = useMemo(
    () =>
      sortedItems?.map((item, idx) => (
        <TableRow
          handleDetails={input.handleDetails}
          handleSearch={input.handleSearch}
          key={idx}
          item={item}
          locale={locale}
        />
      )),
    [sortedItems],
  );

  return (
    <div className={b()}>
      <table className={b('table')}>
        {!!items.length ? (
          <>
            <div className={b('table-header')}>
              {customTableHeaders.map(head => {
                const type = head === 'lastMonthNetwin' ? 'netwin' : 'createdAt';
                return (
                  <div key={head} className={b('table-head')}>
                    {locale[head]}
                    {(head === 'lastMonthNetwin' || head === 'requestDate') && (
                      <SVG
                        onClick={() =>
                          handleSetSortBy({
                            ...sortBy,
                            isOpen: false,
                            type: type,
                            direction: type === sortBy.type ? (sortBy.direction === 'asc' ? 'desc' : 'asc') : 'asc',
                          })
                        }
                        svgProps={{ svg: sortSVG }}
                        className={b('table-head-icon', {
                          type,
                          rotate: sortBy.type === type && sortBy.direction === 'asc',
                        })}
                      />
                    )}
                  </div>
                );
              })}
            </div>
            <div className={b('table-body')}>{rows}</div>
          </>
        ) : (
          <div className={b('no-results')}>{locale.noResults}</div>
        )}
        <div className={b('paginator-wrapper')}>
          <div className={b('extra-info')}>
            {output.requests?.count} {locale.records}
          </div>
          <PaginatorSwitcher
            onPageClick={input.handlePageChange}
            count={output.requests?.count}
            currentPage={input.values.page}
            itemsOnPage={output.activeItemsOnPage}
          />
        </div>
      </table>
      {input.isModalOpen && (
        <Modal
          isDesktop
          withoutBG
          closeFunction={input.resetDetailsModal}
          content={<CustomRequestDetails details={input.detailsData} onClose={input.resetDetailsModal} />}></Modal>
      )}
    </div>
  );
};

export default CustomPageTable;
